import { render, staticRenderFns } from "./CustomerLoyaltyStatus.vue?vue&type=template&id=6c7abfe6&"
import script from "./CustomerLoyaltyStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerLoyaltyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports